import React from "react";
import { Card, Col, Row, Skeleton, Typography } from "antd";
import { SEGMENT, SEGMENT_COLOR } from "../constants/npsConstants";
import "./NPSStatTiles.css";

const { Text } = Typography;

const pct = (value, total) => (total ? ((value / total) * 100).toFixed(1) : "0.0");

const Tile = ({ pillLabel, pillColor, label, value, meta, barPct, barColor }) => (
  <Col xs={12} className="nps-tile-col">
    <Card className="nps-tile" bordered>
      <div className="nps-tile-top">
        {pillColor ? (
          <span className="nps-tile-pill" style={{ color: pillColor.text, background: pillColor.bg }}>
            {pillLabel}
          </span>
        ) : (
          <span className="nps-tile-pill nps-tile-pill-total">{pillLabel}</span>
        )}
        <Text className="nps-tile-label">{label}</Text>
      </div>
      <div>
        <div className="nps-tile-value">{value}</div>
        <div className="nps-tile-meta">{meta}</div>
        {barPct != null && (
          <div className="nps-tile-bar">
            <span style={{ width: `${barPct}%`, background: barColor }} />
          </div>
        )}
      </div>
    </Card>
  </Col>
);

const TileSkeleton = () => (
  <Col xs={12} className="nps-tile-col">
    <Card className="nps-tile" bordered>
      <div className="nps-tile-top">
        <Skeleton.Button active size="small" shape="round" style={{ width: 44 }} />
        <Skeleton.Input active size="small" style={{ width: 90 }} />
      </div>
      <div>
        <Skeleton.Input active size="small" style={{ width: 70, height: 28, display: "block", margin: "14px 0 6px" }} />
        {/* <Skeleton.Input active size="small" style={{ width: 130 }} /> */}
        <div className="nps-tile-bar" />
      </div>
    </Card>
  </Col>
);

const NPSStatTiles = ({ total, responseRate, eligibleResponses, promoters, passives, detractors, isLoading }) => {
  if (isLoading) {
    return (
      <Row gutter={[16, 16]} className="nps-stat-tiles">
        {Array.from({ length: 4 }).map((_, i) => <TileSkeleton key={i} />)}
      </Row>
    );
  }

  return (
    <Row gutter={[16, 16]} className="nps-stat-tiles">
      <Tile
        pillLabel="All"
        label="Total responses"
        value={total.toLocaleString()}
        meta={`${responseRate}% response rate · ${eligibleResponses.toLocaleString()} eligible orders`}
      />
      <Tile
        pillLabel="9–10"
        pillColor={SEGMENT_COLOR[SEGMENT.PROMOTER]}
        label="Promoters"
        value={promoters.toLocaleString()}
        meta={`${pct(promoters, total)}% of responses`}
        barPct={pct(promoters, total)}
        barColor={SEGMENT_COLOR[SEGMENT.PROMOTER].bar}
      />
      <Tile
        pillLabel="7–8"
        pillColor={SEGMENT_COLOR[SEGMENT.PASSIVE]}
        label="Passives"
        value={passives.toLocaleString()}
        meta={`${pct(passives, total)}% of responses`}
        barPct={pct(passives, total)}
        barColor={SEGMENT_COLOR[SEGMENT.PASSIVE].bar}
      />
      <Tile
        pillLabel="0–6"
        pillColor={SEGMENT_COLOR[SEGMENT.DETRACTOR]}
        label="Detractors"
        value={detractors.toLocaleString()}
        meta={`${pct(detractors, total)}% of responses`}
        barPct={pct(detractors, total)}
        barColor={SEGMENT_COLOR[SEGMENT.DETRACTOR].bar}
      />
    </Row>
  );
};

export default NPSStatTiles;
